/**
 * High order function for: forEach fn
 The function comes first then the array.
 Also we used Array.prototype.forEach.call instead of just calling arr.forEach.
 This is so that we can use our forEach function with array like objects, arguments and DOMNodeList.
  usage: forEach(function)(array)
 */
export const forEach = (fn) => {
  return (arr = []) => {
    Array.prototype.forEach.call(arr, fn);
  };
};

/**
 * High order function for: map fn
 The function comes first then the array.
 Also we used Array.prototype.map.call instead of just calling arr.map.
 This is so that we can use our map function with array like objects, arguments and DOMNodeList.
 usage: map(function)(array)
 */
export const map = (fn) => {
  return (arr = []) => {
    return Array.prototype.map.call(arr, fn);
  };
};

/**
 * High order function for: includes value
 The value to be found (a string) comes first, then the "iterable" that can be an array-like object, arguments, DOMNodeList and even a string.
 usage: includes(value)(iterable)
 */
export const includes = (value) => {
  return (iterable = []) => {
    return typeof iterable === 'string'
      ? String.prototype.includes.call(iterable, value)
      : Array.prototype.includes.call(iterable, value);
  };
};

/**
 * High order function for: filter fn
 The function comes first, then the "iterable" that can be an array-like object, arguments, DOMNodeList
 usage: filter(function)(iterable)
 */
export const filter = (fn) => {
  return (iterable = []) => {
    return Array.prototype.filter.call(iterable, fn);
  };
};

export const removeFromArray = (array, index) => {
  if (Boolean(array[index])) {
    array.splice(index, 1);
  }
};
